import React, { useEffect } from 'react';
import useAxios
 from '../../../axios/useAxios';
import { useDispatch, useSelector } from 'react-redux';
import HeaderCart from '../../../components/HeaderCart';
import { useNavigate } from 'react-router-dom';
import { removeCB } from '../../../actions/userCbActions';
import dell from '../../../styles/img/dell.svg';
import addpaymentSvg from '../../../styles/img/addpayment.svg';
import Swal from 'sweetalert2';
import { findUser } from '../../../actions/userActions';
import empty_card from '../../../styles/img/wallet/empty_card.svg';
import BackButton from '../../../components/button/BackButton';
import { ACCOUNT } from '../../../constants/routes';

const Wallet = () => {
  const user = useSelector((state) => state.user);
  const axiosInstance = useAxios();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const creditCard = useSelector((state) => state.user.creditCard) || {};
  const edenredInfo = useSelector((state) => state.user.edenred) || {};
  function parseBalance(amount) {
    const parsedAmout = (amount / 100).toFixed(2).replace('.', ',');
    return parsedAmout;
  }

  useEffect(() => {
    window.scrollTo(0, 0);

    if (user && user._id) {
      dispatch(findUser(user, axiosInstance, navigate));
    }
  }, []);

  return (
    <div className="w-full h-full">
      {user.loading ? (
        <div className="absolute z-50 h-screen w-screen bg-black bg-opacity-50">
          <div className="z-50 absolute left-2/4 top-[25%]  -translate-x-2/4 ">
            <div className="lds-spinner white">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
      <div className="global-header">
        <BackButton onClick={() => navigate(ACCOUNT)} />
        <HeaderCart titre="Mes cartes" />
      </div>
      <div className="wallet-container">
        {user.creditCard[0] && user.creditCard[0].pm ? (
          <>
            <div className="flex items-center border-solid rounded-[0.6em] geomanistBold border-[0.15em] border-[#00000024] justify-between text-black rounded-[1.4em] p-6   w-full">
              <div className="wallet-card">
                <div className="wallet-card-img-box">
                  <img className="wallet-card-img" src={creditCard[0].img} />
                </div>
                <div className="wallet-card-text-group">
                  <div className="wallet-card-text">
                    {' '}
                    <span>.... .... .... &nbsp;</span>{' '}
                    {creditCard[0].last4}{' '}
                  </div>
                  {/* <div className='exp-year'>
                  {creditCard[0].exp_month}/{creditCard[0].exp_year}
                </div> */}
                </div>
              </div>
              <button
                onClick={() => {
                  Swal.fire({
                    title: 'Es-tu sûr(e) de vouloir supprimer cette carte?',
                    showCancelButton: true,
                    icon: 'warning',
                    confirmButtonText: `Oui`,
                    cancelButtonText: `Non`,
                    buttonsStyling: false,
                    customClass: {
                      confirmButton:
                        'w-[100px] h-[40px] bg-[#FF0000] rounded-[10px] text-white geomanistBold text-[1.4rem] p-4',
                      cancelButton:
                        'w-[100px] h-[40px] bg-[#F2F2F2] rounded-[10px] text-[#9C9C9C] geomanistBold text-[1.4rem] p-4',
                    },
                  }).then((result) => {
                    if (result.isConfirmed) {
                      dispatch(
                        removeCB(user._id, creditCard[0], axiosInstance),
                      );
                    }
                  });
                }}
                className=""
              >
                <img src={dell} alt="" />
              </button>
            </div>
          </>
        ) : (
          <></>
        )}
        {/* {edenredInfo && edenredInfo.balance  ? (
        <>
          <div className="edenred_btn formcarte  flex my-8  border-none items-center justify-between rounded-[10px] bg-white text-black h-20 w-full px-8">
            <img
              className="h-14 w-22 mr-2"
              src="https://firebasestorage.googleapis.com/v0/b/pikkopay.appspot.com/o/Webapp%2Fcart%2FEdenred-Logo.png?alt=media&token=48042cb0-3bea-4bb5-948d-4e629a1ae046"
            />
            <span className=" text-lg font-semibold bg-red-100  p-1 px-2 rounded-[5px] text-red-600 ">
              <span className="geomanistBold">
                {parseBalance(edenredInfo.balance.amount)}
              </span>
              € max
            </span>
            <button onClick={() => handleRemoveEdenred()}
              className="deletepayment"
              style={{ marginLeft: 'auto' }}>
                <img src={dell} alt="" />
            </button>
          </div>
        </>
      ) : (<></>)} */}
        {(!user.creditCard[0] && !edenredInfo.balance) ||
        (!user.creditCard[0]?.pm && !edenredInfo.balance) ? (
          <>
            <img src={empty_card} alt="" />
            <div className="empty-text">
              <div className="empty-text-title">Aucune carte renseignée</div>
              <div className="empty-text-description">
                Aucune carte ajoutée pour le moment
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
        <button
          className="payer w-full p-6 geomanistMedium text-[1.7rem] gap-2"
          onClick={() => {
            navigate('/account/wallet/addPaymentScreen');
          }}
        >
          <img src={addpaymentSvg} alt="" />
          Ajouter un moyen de paiement
        </button>
      </div>
    </div>
  );
};

export default Wallet;
